const XLogo = ({ className = "h-3.5 w-3.5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" focusable="false">
    <path d="M18.9 2.1h3.4l-7.4 8.5 8.7 11.5h-6.8L11.5 15 5.6 22.1H2.2l7.9-9.1L1.7 2.1h7l4.9 6.5 5.3-6.5Zm-1.2 18h1.9L7.4 4H5.4l12.3 16.1Z" />
  </svg>
);

export default XLogo;
